var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticStyle:{"width":"600px"},attrs:{"shadow":"never"}})
}
var staticRenderFns = []

export { render, staticRenderFns }